import { InternalLedgerSchema } from '@fastre/core/schemas/ledger'
import { CheckCircleRounded } from '@mui/icons-material'
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    ModalDialog,
    Stack,
    Textarea,
    Typography,
} from '@mui/joy'
import { useApi } from 'api'
import { LedgerApiContext, useBulkLedgerApi } from 'apiProviders'
import Modal, { dontCloseOnBackgroundClick } from 'components/modal'
import { useEffect, useState } from 'react'

interface Props {
    ledgerItem?: InternalLedgerSchema
    setLedgerItem: (ledgerItem: InternalLedgerSchema | undefined) => void
    ledgerApi: Omit<LedgerApiContext, 'subscribe' | 'unsubscribe'>
}

export default function ResolveDisputeModal({ ledgerItem, setLedgerItem, ledgerApi }: Props) {
    const api = useApi()
    const bulkLedgerApi = useBulkLedgerApi(false)

    const [resolution, setResolution] = useState('')
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setResolution(ledgerItem?.resolution ?? '')
    }, [ledgerItem])

    const onClose = () => setLedgerItem(undefined)

    return (
        <Modal
            open={ledgerItem != undefined}
            onClose={dontCloseOnBackgroundClick(onClose)}
        >
            <ModalDialog>
                <DialogTitle>Resolve Dispute</DialogTitle>
                <DialogContent>
                    <Stack spacing={2}>
                        <Stack spacing={0.5}>
                            <Typography level="title-sm">Dispute Reason</Typography>
                            <Typography>{ledgerItem?.disputeReason}</Typography>
                        </Stack>
                        <Textarea
                            minRows={3}
                            value={resolution}
                            onChange={event => setResolution(event.target.value)}
                            placeholder="Enter resolution details"
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="success"
                        startDecorator={<CheckCircleRounded />}
                        loading={loading}
                        disabled={!resolution.trim()}
                        onClick={async () => {
                            if (!ledgerItem) {
                                return
                            }
                            setLoading(true)
                            await api.post(`/ledger/resolvedispute`, {
                                id: ledgerItem.id,
                                resolution: resolution.trim(),
                            })
                            await ledgerApi.refresh()
                            bulkLedgerApi.refresh()
                            setLoading(false)
                            onClose()
                        }}
                    >
                        Resolve
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </ModalDialog>
        </Modal>
    )
}
